import AdminHttpClient from './AdminHttpService';

function getEmailLogs(params) {
    return AdminHttpClient.get('/emails', { params });
}

export default {
    getEmailLogs
};
